import { css } from '@emotion/core';
import React, {
  useContext,
  useEffect,
} from 'react';
import t from 'react-translate';

// Contexts
import { CommunicationDispatch, CommunicationAction } from 'course_communications/contexts/communication-context';

// Contexts
import { CommunicationFormContext, UseCommunicationMethods, FormSubmittedState } from 'course_communications/hooks/use-communication-form';

// Components
import { NvFroala } from 'froala/components/nv-froala';
import { FroalaViewMode, RteTagValue, UploadType } from 'froala/helpers/nv-froala-constants';
import NvTextInput from 'shared/components/inputs/nv-text-input';
import { ViewMode } from 'redux/schemas/models/course-communication';
import CommunicationEmailPreview from 'course_communications/components/communication-item/communication-email-preview';
import EmailHeader from '../email-header';
import { config } from '../../../../../config/config.json';

const styles = (ShowForm: boolean) => css`
  &.welcome-email-form {
    display: ${ShowForm ? 'block' : 'none'};
  }
`;
const SendTo = () => (
  <div>
    <span className='page-title-small pr-2'>
      {t.COURSE_COMMUNICATIONS.SCHEDULED_EMAIL.TO()}
    </span>
    <span className='text-large-body font-weight-bolder'>
      {t.COURSE_COMMUNICATIONS.WELCOME_EMAIL.RECIPIENT()}
    </span>
  </div>
);

type Props = {
  catalogId: string,
};

const WelcomeEmailForm = (props: Props) => {
  const { dispatch, State } = useContext(CommunicationDispatch);
  const { formSubmitState, formData, getCommunicationDraft } = useContext<UseCommunicationMethods>(CommunicationFormContext);

  const communicationDraft = getCommunicationDraft();

  useEffect(() => {
    if (formSubmitState === FormSubmittedState.SUBMITTED) {
      dispatch({ type: CommunicationAction.CLOSE_MODAL });
    }
  }, [formSubmitState, dispatch]);

  return (
    <React.Fragment>
      {State.viewMode === ViewMode.EMAIL_PREVIEW && (
        <React.Fragment>
          <SendTo />
          <div className='mt-3 mb-4'>
            <EmailHeader
              communicationDraft={communicationDraft}
              catalogId={props.catalogId}
            />
            <CommunicationEmailPreview
              catalogId={props.catalogId}
              subject={formData.emailSubject}
              body={formData.emailBody}
              communicationType={formData.communicationType}
            />
          </div>
        </React.Fragment>
      )}
      <div
        css={styles(State.viewMode === ViewMode.FORM_VIEW)}
        className='welcome-email-form mt-2'
      >
        <SendTo />
        <div className='w-100'>
          <div className='my-4'>
            <NvTextInput
              name='emailSubject'
              autoComplete='off'
              inputClassName='text-medium'
              required
              withForm
            />
          </div>
          <div className=''>
            <NvFroala
              preset={FroalaViewMode.NORMAL}
              withCodeView
              withInsertTag
              name='emailBody'
              uploadType={UploadType.IMAGE_ONLY}
              withForm
              extraTags={[RteTagValue.INSERT_PASSWORD_SENTENCE]}
              fileExtensions={config.files.rte.images.common}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WelcomeEmailForm;
